import i18next from 'i18next';

import { LANGUAGE_KEYS } from '~constants/languages';

i18next.addResources(LANGUAGE_KEYS.CHILE, 'CustomOptionLabel', {
  pay: '¡Pagas {{price}}!'
});
